 import React from 'react';
import { X, MessageSquare, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';

interface ContactSuccessPopupProps {
  isOpen: boolean;
  recipientName: string;
  onClose: () => void;
  onGoToInbox: () => void;
}

const ContactSuccessPopup: React.FC<ContactSuccessPopupProps> = ({
  isOpen,
  recipientName,
  onClose,
  onGoToInbox
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b border-gray-200">
          <div className="flex items-center space-x-3">
            <CheckCircle className="w-6 h-6 text-green-500" />
            <h3 className="text-lg font-medium text-gray-900">
              Message Sent Successfully
            </h3>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="mb-6 text-center">
            <p className="text-gray-700 mb-4">
              Message sent to <span className="font-semibold">{recipientName}</span>
            </p>
            
            <Button
              variant="outline"
              size="sm"
              onClick={onGoToInbox}
              className="mb-4"
            >
              <MessageSquare className="w-4 h-4 mr-2" />
              Go to conversation in Inbox
            </Button>
          </div>

          {/* Action buttons */}
          <div className="flex justify-center">
            <Button
              variant="outline"
              size="sm"
              onClick={onClose}
            >
              OK
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSuccessPopup; 